import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { SectionInner } from '../components/SectionInner';
import { CornerFrame } from '../components/CornerFrame';

export function NotAStage() {
  const { notAStage } = conventionContent;
  return (
    <Box
      component='section'
      id={notAStage.sectionId}
      aria-labelledby={notAStage.headingId}
      sx={{
        backgroundColor: 'background.paper',
        paddingBlock: { mobile: pxToRem(48), laptop: pxToRem(120) },
      }}
    >
      <SectionInner
        direction={{ mobile: 'column', laptop: 'row' }}
        gap={{ mobile: pxToRem(48), laptop: pxToRem(127) }}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: { mobile: pxToRem(301), laptop: pxToRem(257) },
            height: { mobile: pxToRem(240), laptop: pxToRem(289.5) },
            flexShrink: 0,
          }}
        >
          <CornerFrame
            corner='bottom-left'
            inset={{
              mobile: { horizontal: 16, vertical: 19 },
              laptop: { horizontal: 17, vertical: 24.5 },
            }}
            radius={{ mobile: 27, laptop: 22 }}
          />
          <Stack
            gap={pxToRem(24)}
            sx={{
              position: 'absolute',
              top: { mobile: pxToRem(7), laptop: 0 },
              left: { mobile: '50%', laptop: pxToRem(28) },
              transform: { mobile: 'translateX(-50%)', laptop: 'none' },
              width: { mobile: pxToRem(255), laptop: pxToRem(229) },
              alignItems: { mobile: 'center', laptop: 'flex-start' },
              textAlign: { mobile: 'center', laptop: 'left' },
              color: 'primary.main',
            }}
          >
            <Typography
              component='h2'
              id={notAStage.headingId}
              variant='h2'
              sx={{
                fontSize: { mobile: pxToRem(24), laptop: pxToRem(32) },
                lineHeight: { mobile: pxToRem(32), laptop: pxToRem(40) },
                margin: 0,
                width: '100%',
              }}
            >
              {notAStage.headingLines.map((line, i) => (
                <Box component='span' key={i} sx={{ display: 'block' }}>
                  {line}
                </Box>
              ))}
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Roboto", sans-serif',
                fontWeight: 700,
                fontSize: { mobile: pxToRem(16), laptop: pxToRem(18) },
                lineHeight: { mobile: pxToRem(20), laptop: pxToRem(24) },
                margin: 0,
              }}
            >
              {notAStage.lead}
            </Typography>
          </Stack>
        </Box>

        <Stack
          direction='row'
          flexWrap='wrap'
          gap={{ mobile: pxToRem(40), laptop: pxToRem(52) }}
          sx={{
            width: { mobile: pxToRem(297), laptop: pxToRem(736) },
            columnGap: { mobile: pxToRem(40), laptop: pxToRem(128) },
            rowGap: { mobile: pxToRem(40), laptop: pxToRem(52) },
            justifyContent: { mobile: 'space-between', laptop: 'flex-start' },
          }}
        >
          {notAStage.cards.map((card, index) => (
            <Stack
              key={index}
              gap={pxToRem(12)}
              sx={{
                width: { mobile: pxToRem(128), laptop: pxToRem(160) },
                alignItems: { mobile: 'center', laptop: 'flex-start' },
                textAlign: { mobile: 'center', laptop: 'left' },
                color: 'primary.main',
              }}
            >
              <Box
                component='img'
                src={card.iconSrc}
                alt={card.iconAlt}
                aria-hidden='true'
                sx={{
                  width: pxToRem(64),
                  height: pxToRem(64),
                  display: 'block',
                  objectFit: 'contain',
                }}
              />
              <Stack gap={0}>
                <Typography
                  component='p'
                  sx={{
                    fontFamily: '"Roboto", sans-serif',
                    fontWeight: 700,
                    fontSize: { mobile: pxToRem(14), laptop: pxToRem(16) },
                    lineHeight: pxToRem(20),
                    margin: 0,
                  }}
                >
                  {card.title}
                </Typography>
                <Typography
                  component='p'
                  sx={{
                    fontFamily: '"Roboto", sans-serif',
                    fontWeight: 400,
                    fontSize: { mobile: pxToRem(14), laptop: pxToRem(16) },
                    lineHeight: pxToRem(20),
                    margin: 0,
                  }}
                >
                  {card.body}
                </Typography>
              </Stack>
            </Stack>
          ))}
        </Stack>
      </SectionInner>
    </Box>
  );
}
